import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ProcessingAnimation from "../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import { get } from "../../../../modules/get.js";
import { Container } from "../../../client/components/index.js";
import { updateStyle } from "../../../client/gallery/scripts/useStyle.js";
export default function LoginSiteMain(props) {
    const [data, setData] = useState();
    const { siteName } = useParams();
    useEffect(() => {
        get(`/api/c/${siteName}/data`).then((res) => {
            setData(res);
        });
    }, []);
    if (!data)
        return React.createElement(ProcessingAnimation, null);
    if (data.status !== 200)
        return React.createElement(React.Fragment, null, "Nieprawid\u0142owe rz\u0105danie");
    const { data: content } = data;
    updateStyle(content === null || content === void 0 ? void 0 : content.style, "default");
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { bodyMessage: content === null || content === void 0 ? void 0 : content.bodyMessage, title: content === null || content === void 0 ? void 0 : content.title })));
}
